<template>
  <div class="i-detail-similar" v-if="similar_data">
    <div :class="similar_over ? 'i-detail-similar-left' : 'i-detail-similar-left hide'" @click="scrollLeft()" @mouseover="similar_over = true" @mouseleave="similar_over = false">
      <font-awesome-icon :icon="['far', 'chevron-left']" />
    </div>
    <div :class="similar_over ? 'i-detail-similar-right' : 'i-detail-similar-right hide'" @click="scrollRight()" @mouseover="similar_over = true" @mouseleave="similar_over = false">
      <font-awesome-icon :icon="['far', 'chevron-right']" />
    </div>
    <div class="i-detail-similar-title">
      <div class="flex-row">
        <div class="header-sns" :class="sns_type" style="margin-right: 10px;">
          <svg v-if="sns_type === 'twitter'" width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
          </svg>  
          <font-awesome-icon v-else :icon="['fab', sns_type]" />
        </div>
        <div>類似アカウント</div>
      </div>
      <div class="flex-space"></div>
      <div class="check-wrap" v-show="checkList.length > 0">
        <div class="check-parts" style="color:#666">{{ checkList.length }}名を選択中</div>
        <div class="check-parts pointer" @click="checkList = []"><i class="el-icon-remove-outline" style="font-size:14px;"></i>全員の選択を解除</div>
        <addListButton :checkList.sync="checkList" :sns_type="sns_type" />
      </div>
      <el-dropdown trigger="click" style="margin-left: 20px;" v-show="checkList.length == 0">
        <el-button type="default" size="small" class="report-media-sort-button" style="width:auto">
          {{ sort_similar_description }}
          <font-awesome-icon icon="caret-down" style="margin-left:5px" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="sortSimilarBy('followers_count', 'desc', 'フォロワー数が多い順')">フォロワー数が多い順</el-dropdown-item>
          <el-dropdown-item @click.native="sortSimilarBy('followers_count', 'asc', 'フォロワー数が少ない順')">フォロワー数が少ない順</el-dropdown-item>
          <el-dropdown-item @click.native="sortSimilarBy('average_engagement_rate', 'desc', 'EGRが高い順')">EGRが高い順</el-dropdown-item>
          <el-dropdown-item @click.native="sortSimilarBy('average_engagement_rate', 'asc', 'EGRが低い順')">EGRが低い順</el-dropdown-item>
          <el-dropdown-item v-show="sns_type=='instagram' || sns_type =='youtube'" @click.native="sortSimilarBy('female_ratio', 'desc', 'フォロワー女性比率が高い順')">フォロワー女性比率が高い順</el-dropdown-item>
          <el-dropdown-item v-show="sns_type=='instagram' || sns_type =='youtube'"  @click.native="sortSimilarBy('male_ratio', 'desc', 'フォロワー男性比率が高い順')">フォロワー男性比率が高い順</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-if="!similar_data[0]" v-loading="!similar_data[0]" class="detail-img-loading" style="width: 100%; min-height: 100px; z-index:5;" id="similar-wrap"></div>
    <div class="i-detail-similar-wrap" @mouseover="similar_over = true" @mouseleave="similar_over = false" id="similar-wrap" v-else>
      <div
        class="i-detail-similar-account"
        :class="sns_type"
        v-for="(similar, similar_index) in similar_data"
        :key="similar.account_name"
        @mouseover="similar_over_account = similar.id"
        @mouseleave="similar_over_account = ''"
      >
        <div class="i-detail-similar-listin" v-if="similar.list_count > 0">
          <el-tooltip placement="bottom-start">
            <div slot="content" class="data-table-th-listname-list">
              <span v-for="list_in in similar.list_in" :key="list_in.list_id" style="margin-right:5px">
                <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
                {{ list_in.list_name }}
                <br /> </span
              >に追加されています
            </div>
            <span>
              <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
              {{ similar.list_count }}
            </span>
          </el-tooltip>
        </div>
        <div class="i-detail-similar-check" :class="checkList.includes(similar.id) ? 'show' : ''">
          <!-- <el-checkbox v-model="checkList" :label="similar.id"></el-checkbox> -->
          <div class="data-table-th-checkbox">
              <input type="checkbox" class="checkbox-original" v-model="checkList" :value="similar.id" :id="similar.id + 'similar-checkbox'" />
              <label class="checkbox_inner" :for="similar.id + 'similar-checkbox'"> </label>
            </div>
        </div>
        <div
          class="pointer"
          style="width:100%"
          @click.exact="toInfluencerDetail(sns_type != 'youtube' ? similar.account_name : similar.id)"
          @click.ctrl.exact="toInfluencerDetailNewWindow(sns_type != 'youtube' ? similar.account_name : similar.id)"
          @click.meta.exact="toInfluencerDetailNewWindow(sns_type != 'youtube' ? similar.account_name : similar.id)"
        >
          <div class="i-detail-similar-box image">
            <div class="data-table-th-picture-favorite similar" v-if="similar.favorite == 1">
              <font-awesome-icon :icon="['fas', 'star']" style="font-size:12px" />
            </div>
            <img v-bind:src="similar.profile_picture_url" class="data-table-profile" @error="e => { e.target.src = s3BaseUrl + '/userdata/img_error.png'; }" />
          </div>
          <div class="i-detail-similar-box">
            <div class="i-detail-similar-account_name">
              {{ similar.account_name }}
              <img src="../../../assets/badge.png" style="width:14px; height:14px; margin-left:5px" v-show="similar.badge == '1' && sns_type != 'tiktok'" />
              <font-awesome-icon :icon="['fas', 'check-circle']" v-show="similar.badge == '1' && sns_type == 'tiktok'" class="tt-badge" />
            </div>
            <div class="i-detail-similar-name">
              {{ similar.name }}
              <span v-if="similar.name && similar.age"> | </span>
              <span v-if="similar.age">{{ similar.age }}歳</span>
            </div>
          </div>
        </div>
        <div class="i-detail-similar-post-wrap">
          <div v-for="(post, post_index) in similar.post_data" :key="post" class="i-detail-similar-post">
            <img :src="post+'?name=120x120'" @error="imgErrorSimilarPost(similar_index, post_index)" alt=""/>
          </div>
        </div>
        <div class="i-detail-similar-box" style="flex-flow:row; margin-bottom:5px; align-items:flex-end" v-if="sns_type=='youtube' && similar.followers_count == 0">
          <span style="font-size:8px; color:#aaa">登録者数非公開</span>
        </div>
        <div class="i-detail-similar-box" style="flex-flow:row; margin-bottom:5px; align-items:flex-end" v-else>
          <div class="i-detail-similar-followers">{{ similar.followers_count | localString }}</div>
          <span style="font-size:8px; color:#aaa">フォロワー</span>
        </div>
        <div class="i-detail-similar-box" style="flex-flow:row; align-items:flex-end">
          <span style="font-size:8px; color:#aaa; margin-right:5px">EGR</span>
          <div class="i-detail-similar-followers">{{ similar.average_engagement_rate }}</div>
          <span style="font-size:8px; color:#aaa">%</span>
        </div>
        <div class="i-detail-similar-box" style="flex-flow:row; align-items:flex-end" v-if="sns_type=='instagram' || sns_type == 'youtube'">
          <genderRatio style="width:50%" :female_ratio="similar.female_ratio" :male_ratio="similar.male_ratio" />
        </div>
        <div class="i-detail-similar-box category" v-if="sns_type=='instagram'">
          <div class="i-detail-similar-categoryoverlay"></div>
          <div class="category" v-if="similar.category">
            <div class="category-box-list similar" v-for="category in similar.category.category_data" :key="category.cateogory_name">&nbsp;{{ category.category_name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addListButton from "../../list/add_list_button";
import genderRatio from "../../list/gender_ratio";

export default {
  name: "similarAccount",
  props: ["similar_data", "sns_type"],
  components: {
    addListButton,
    genderRatio,
  },
  data() {
    return {
      checkList: [],
      similar_over: false,
      similar_over_account: "",
      sort_similar_description: "並び替え",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {

  },
  mounted() {
    
  },
  methods: {
    toInfluencerDetail(account_name) {
      this.$emit("toInfluencerDetail", account_name);
    },
    toInfluencerDetailNewWindow(account_name) {
      this.$emit("toInfluencerDetailNewWindow", account_name);
    },
    sortSimilarBy(sort_similar_key, sort_similar_order, sort_similar_description) {
      this.sort_similar_description = sort_similar_description;
      if (sort_similar_order == "desc") {
        this.sortSimilarDesc(sort_similar_key);
      } else {
        this.sortSimilarAsc(sort_similar_key);
      }
      this.scrollReset();
    },
    sortSimilarDesc(sort_similar_key) {
      this.similar_data.sort(function(a, b) {
        return a[sort_similar_key] > b[sort_similar_key] ? -1 : 1;
      });
    },
    sortSimilarAsc(sort_similar_key) {
      this.similar_data.sort(function(a, b) {
        return a[sort_similar_key] < b[sort_similar_key] ? -1 : 1;
      });
    },
    scrollReset() {
      var itemArea = document.getElementById("similar-wrap");
      itemArea.scrollLeft = 0;
    },
    scrollLeft() {
      var itemArea = document.getElementById("similar-wrap");
      itemArea.scrollLeft -= 800;
    },
    scrollRight() {
      var itemArea = document.getElementById("similar-wrap");
      itemArea.scrollLeft += 800;
    },
    imgErrorSimilarPost(index, post_index) {
      this.similar_data[index].post_data[post_index] = this.s3BaseUrl + "/postdata/error.jpg";
    },
  },
  filters: {
    localString(val) {
      return val.toLocaleString();
    },
  },
  watch: {
    similar_data: {
      handler() {
        this.sort_similar_description = "並び替え";
        this.scrollReset();
      },
      deep: true,
    },
  },
};
</script>

<style></style>
